import {
  ComputedPropertiesAPI,
  PurchaseInfo,
  SB,
  computedProperty,
  createComputedProperties,
} from '@play-co/replicant';
import { stateSchema } from '../State';
import * as Pet from '../pet';

function gelLastPurchaseData(api: ComputedPropertiesAPI): PurchaseInfo | null {
  const history = api.purchases.getPurchaseHistory();
  return history.length ? history[history.length - 1] : null;
}

export default createComputedProperties(stateSchema)({
  adminProfileLtv: computedProperty(
    SB.number(),
    (state) => (state.lifetimeValue + state.actualLTV) / 100,
  ),

  adminProfileCreatedAt: computedProperty(
    SB.number(),
    (state) => state.createdAt,
  ),

  adminProfileUpdatedAt: computedProperty(
    SB.number(),
    (state) => state.updatedAt,
  ),

  adminProfileFreeGems: computedProperty(
    SB.number(),
    (state) => state.inventory.premium.free,
  ),

  adminProfilePaidGems: computedProperty(
    SB.number(),
    (state) => state.inventory.premium.paid,
  ),

  adminProfilePoints: computedProperty(
    SB.number(),
    (state) => state.inventory.points,
  ),

  adminProfileSuperLollipopStreak: computedProperty(
    SB.number(),
    (state) => state.superLollipop?.winStreak ?? 0,
  ),

  adminProfileLastPurchaseName: computedProperty(
    SB.string(),
    (_state, api) => gelLastPurchaseData(api)?.product_id || '',
  ),

  adminProfileLastPurchaseDate: computedProperty(
    SB.int(),
    (_state, api) => gelLastPurchaseData(api)?.purchase_time || 0,
  ),

  adminPetName: computedProperty(SB.string(), (state) => state.pet.name),

  adminPetSpecies: computedProperty(
    SB.string().optional(),
    (state) => Pet.getters.getCurrentEvolution(state)?.species,
  ),
});
